<ng-container *ngIf="archiveDocument !== undefined else emptyTemplate">
    <span id="entity-modal-label" class="sr-only">{{ archiveDocument.title }}</span>
    <div class="wrapper">
        <div class="tab-view-container">
            <app-tablet-view-tabs [detailsView]="detailsView"
                (viewChanged)="onViewChanged($event)"></app-tablet-view-tabs>
        </div>
        <div class="content" [ngClass]="{'map-view': detailsView === eDetailsView.Map}">
            <div class="details-content" [ngClass]="{'with-image-preview': archiveImages}">
                <app-scientific-archive-document-details [details]="archiveDocument" [images]="archiveImages" [thumbnails]="archiveThumbnails"
                  [currentLanguage]="currentLanguage"  (viewFolder)="OnViewFolder($event)"></app-scientific-archive-document-details>
            </div>
            <div class="map-content">
                <app-scientific-archive-map [shapes]="shapes" [zoomShapeIds]="zoomShapeIds" [header]="'iaa.general.map'| translate"
                    [fromLocus]="true" [needZoom]="true"></app-scientific-archive-map>
            </div>
        </div>
        <div class="error">{{'iaa.scientificArchiveDocument.errorMessage' | translate }}</div>
        <div class="action">
            <!-- <div class="action-header">
                <h4>{{ 'iaa.aria.additionalAction' | translate}}</h4>
            </div> -->
            <div>
                <p-button styleClass="icon-button"  [ngClass]="{'icon-button':true,'en': (currentLanguage | async)=== 'en'}" [link]="true" icon="pi pi-download" [label]="'iaa.aria.btnDownloadDoc' | translate"
                    [tabindex]="0" [ariaLabel]="'iaa.aria.btnDownloadDoc' | translate" (keydown.enter)="handlePdf()"
                    (click)="handlePdf()" />
            </div>
        </div>
    </div>
</ng-container>
<ng-template #emptyTemplate>
    <p-messages closable="false" styleClass="custom-error" />
    <app-skeleton-document *ngIf="!hasError"></app-skeleton-document>
</ng-template>